import React, { useCallback, useContext, useEffect, useState } from "react";
import { ACTIONS, USERTYPES } from "../../../../constants/Constants";
import { t, use } from "i18next";
import CustomCheckBox from "../../../Hospital/components/HeaderFileChecks/CustomCheckBox";
import {
    Checkbox,
  ComboBox,
  DirectionalHint,
  Dropdown,
  SelectableOptionMenuItemType,
  TooltipDelay,
  TooltipHost,
} from "@fluentui/react";
import { useSearchParams } from "react-router-dom";
import userContext from "../../../../context/users/UserContext";
import ClearIcon from "../../../../components/SVGComponents/ClearIcon";
import AutoAssignModalitySubModality from "./AutoAssignModalitySubModality";
import { getModalityList } from "../../../../service/FirmServices";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { getEnv } from '../../../../helpers/EnvHelper';


const AutoAssignmentAccess = (props) => {
    const [searchParams] = useSearchParams();
    const { roles, authenticated, loadByUsername, userId } =
      useContext(userContext);

  const [autoAssignEnabled, setAutoAssignEnabled] = useState(props.values.autoAssignEnable);
  const [selectedModality, setSelectedModality] = useState([]);
  const [modalityList, setModalityList] = useState([]);
  const [modalityWithSubModalityList, setModalityWithSubModalityList] = useState(props.modalityWithSubModalityList);
  const [checkAllModality, setCheckAllModality] = useState(false);
  const [pediatricAssignmentEnabled, setPediatricAssignmentEnabled] = useState(props.values.pediatricAssignmentEnabled);
  const [selectedPediatricModalityId, setSelectedPediatricModalityId] = useState(props.values.selectedPediatricModalityId);
  
    useEffect(() => {
      if (!authenticated) {
        loadByUsername();
      }
    }, []);

    useEffect(()=>{
      if(props.action == "ADD"){
                fetchModalityList();
      }
    },[props.action])

    useEffect(()=>{
      if(props.action == "ADD"){
                fetchSubModalityList();
      }
    },[modalityList])

    const fetchModalityList = async () => {
      const response = await getModalityList();
      if (response.status === 200) {
        let mdl = [];
                response.data.data.map((modality) => {
          mdl.push({
            key: modality.id,
            text: modality.name,
          });
        });
        setModalityList(mdl);
      }
    };

    const fetchSubModalityList = () => {
      let modSubmod = [];
      modalityList.map((mod)=>{
        modSubmod.push({
          id : mod.key,
          name : mod.text,
          subModality : []
        })
      })
      setModalityWithSubModalityList(modSubmod);
    }
    
    //let modalityList = [];
    props?.modalityList?.forEach((modality) => {
      const isKeyExists = modalityList.some(item => item.key === modality.id);
      if (!isKeyExists) {
          modalityList.push({
              key: modality.id,
              text: modality.name,
          });
      }
    });

    const getAllSubModName = (list,keyIndex) => {
      let allsubModString = "";
      let isOverFlow = false;
      list?.map((item,index) => {
        if(index >= keyIndex && index-keyIndex < 20){
          allsubModString += list[index];
          if (index < list.length - 1) {
            allsubModString += ", ";
          }
        } else{
          isOverFlow = true;
        } 
      });
      if(isOverFlow){
        allsubModString += "...";
      }
      return allsubModString;
    }

    const getFormattedSubModalities = (modality) =>{
      let subModName = [];
      modality?.subModalities.map((subMod, index)=>{
        subModName.push(subMod.serviceCode + ": " + subMod.serviceName);
      })
      let list2 = "";
      {subModName.map((modality,index)=>{
        if(index < 5){
          list2 += modality + ", ";
        }  
      })}
      return (<>
      {getAllSubModofModFunc(modality, true) ? <div >
        <td style={{border:"none",padding:"8px",textAlign:"left"}}>
        {list2}
        <CustomToolTipHost content={getAllSubModName(getAllSubModofModFunc(modality, false),5)}>
           ....
        </CustomToolTipHost>
        </td>
        </div> : <td style={{border:"none",padding:"8px",textAlign:"left"}}>{list2}</td>
      }
      </> )
    }

    const getAllSubModofModFunc = (modality, len) =>{
      let subModName = [];
      modality?.subModalities.map((subMod, index)=>{
        subModName.push(subMod.serviceCode + ": " + subMod.serviceName);
      })
      if(len){
        if(subModName.length > 5){
          return true;
        }
        return false;
      }else{
        return subModName;
      }
    }

    const handleModalityAccToFlag = () =>{
      setAutoAssignEnabled((prev) => !prev);
      props.values.autoAssignEnable = !props.values.autoAssignEnable;
      if(!props.values.autoAssignEnable){
        props.values.exactMatchEnable = false;
        props.values.autoAssignModalityWithSubModalityIds = [];
        props.setSelectedModalityAndSubModality([]);
        props.values.pediatricAssignmentEnabled = false;
        props.values.selectedPediatricModalityId = [];
        setSelectedModality([]);
        setPediatricAssignmentEnabled(false);
        setSelectedPediatricModalityId([]);
      }
    }

    const selectedModalityfunc = () =>{
      setSelectedModality(props.selectedModalityAndSubModality.map((m)=>m.modalityId));
    }

    const handleAllModalityCheckboxClick = () => {
      if (checkAllModality) {
          props.setSelectedModalityAndSubModality([]);
          setCheckAllModality(false);
      } else {
          const allSelectedModalityWithSubModality = modalityWithSubModalityList.map(modality => ({
              modalityId: modality.id,
              subModalities: modality.subModality.map(subModality => subModality.id)
          }));
  
          props.setSelectedModalityAndSubModality(allSelectedModalityWithSubModality);
          setCheckAllModality(true);
      }
    };
  
    useEffect(()=>{
      selectedModalityfunc();
      console.log("Selected Modality with sub modality : ", props.selectedModalityAndSubModality);
      const allModalitiesSelected = modalityWithSubModalityList.length == 0 ? false : modalityWithSubModalityList.every(modality => {
        return props.selectedModalityAndSubModality.some(selectedModality => selectedModality.modalityId === modality.id);
      });
      setCheckAllModality(allModalitiesSelected);
    },[props.selectedModalityAndSubModality]);

    const handlePediatricAssignmentEnable = useCallback(() =>{
      setPediatricAssignmentEnabled(!pediatricAssignmentEnabled);
      props.values.pediatricAssignmentEnabled = !props.values.pediatricAssignmentEnabled;
      if(!pediatricAssignmentEnabled){
        console.log("modality list :",modalityList);
        setSelectedPediatricModalityId(modalityList.filter((m) => m.key != undefined).map((mod)=>mod.key))
      }
    });

    const handlePediatricModalityClearButton = ()=>{
      setSelectedPediatricModalityId([]);
    }

    const getModalityNames = (modalityIds) => {
      let modalityNames = [];
      modalityNames = props.modalityList
        .filter((m) => modalityIds.includes( m.id))
        .map((modality) => modality.name);
      return modalityNames.join(", ");
    };

    useEffect(()=>{
      console.log("selected pediatric modalityIds :",selectedPediatricModalityId);
      props.values.selectedPediatricModalityId = selectedPediatricModalityId;
    },[selectedPediatricModalityId])

  
    return (
      <>
      <div className="tab-section">
      {((roles[0] === USERTYPES.FIRMADMIN)) && <>
            {modalityList?.length > 0 && (props.action == ACTIONS.ADD || props.action == ACTIONS.EDIT)
              && (
                <div className="ms-Grid" dir="ltr">
                  <section className="sectionA"  style={{marginTop: "1.5rem"}}>
                    <p
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        padding: "0px 0px",
                      }}
                    >
                      {t("hospital.auto-assignment-settings")}
                    </p>
                  </section>
                  <div style={{ display: "flex", maxHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-auto-assignment")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.autoAssignEnable}
                          onChangeCustom={() => {
                            handleModalityAccToFlag()
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {!!autoAssignEnabled && (
                    <>

                      <div style={{ display: "flex", maxHeight: "40px" }}>
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                          <p className="single-line-form-field-key">
                            {t("hospital.enable-pediatric-assignment")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div style={{ marginTop: "5px" }}>
                            <CustomCheckBox
                              parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                              values={props.values.pediatricAssignmentEnabled}
                              onChangeCustom={(e, isChecked) => handlePediatricAssignmentEnable(isChecked)}
                            />
                          </div>
                        </div>
                      </div>
                      {pediatricAssignmentEnabled && (
                        <>
                          <div style={{ display: "flex", maxHeight: "60px" }}>
                            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                              <p className="single-line-form-field-key">
                                {t("hospital.pediatric-assignment-modality")}
                              </p>
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 single-line-form-field-value" style={{ display: "flex", alignItems: "center", color: "white", position: 'relative' }}>
                              <div className="ms-sm12 ms-md8 ms-lg6 ms-xl10">
                                <ComboBox
                                  selectedKey={selectedPediatricModalityId}
                                  placeholder="Select Modality"
                                  options={[...modalityList]}
                                  multiSelect
                                  calloutProps={{ doNotLayer: true }}
                                  onChange={(e, option) => {
                                    let selected = option?.selected;
                                    if (option) {
                                      setSelectedPediatricModalityId((prevSelectedKeys) =>
                                        selected ? [...prevSelectedKeys, option.key]
                                          : prevSelectedKeys.filter((k) => k !== option.key ));}
                                  }}
                                />

                              {props.errorState?.pediatricModalityIds?.error && (
                                <div style={{ position: 'absolute', left: '10px'}}>
                                  <span style={{ color: "red", fontSize: "12px", fontWeight: "400" }}>{props.errorState?.pediatricModalityIds?.msg}</span>
                                </div>
                              )}

                              </div>
                              <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={()=> handlePediatricModalityClearButton()} style={{ paddingLeft: "5px"}}>
                                  <CustomToolTipHost content="Clear"  >
                                    <ClearIcon></ClearIcon>
                                  </CustomToolTipHost>
                              </div>
                            </div>
                          </div>
                        </>
                      )}


                      <div style={{ display: "flex", maxHeight: "40px", marginTop: "30px"  }}>
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                          <p className="single-line-form-field-key">
                            {t("hospital.enable-exact-match")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div style={{ marginTop: "5px" }}>
                            <CustomCheckBox
                              parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                              values={props.values.exactMatchEnable}
                              onChangeCustom={() => {
                                props.values.exactMatchEnable =
                                  !props.values.exactMatchEnable;
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="ms-Grid-row">
                        <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl9" style={{ marginBottom: "20px"}}>
                          <span className="form-field-key" style={{ fontWeight: "bold" }}>
                            Select Auto Assignment Modality
                          </span>
                          {props.errorState?.autoAssignModalityIds?.error == true && <span style={{
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "red",
                          }}>{props.errorState.autoAssignModalityIds.msg}
                          </span>}
                        </div>
                      </div>

                      <div className="ms-Grid-row">
                        <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4">
                          <Checkbox
                            label="Select All"
                            onChange={handleAllModalityCheckboxClick}
                            id="all"
                            checked={checkAllModality==true}
                          />
                        </div>
                      </div>

                      <div className="ms-Grid-row">
                        {modalityWithSubModalityList.map((modality,index) => {
                          return (
                            <AutoAssignModalitySubModality
                              index={index}
                              modality={modality}
                              modalityList={props.modalityList}
                              values={props.values}
                              errorState={props.errorState}
                              selectedModalityfunc={selectedModalityfunc}
                              setSelectedModalityAndSubModality={props.setSelectedModalityAndSubModality}
                              selectedModalityAndSubModality={props.selectedModalityAndSubModality}
                              setSelectedModality={setSelectedModality}
                              selectedModality={selectedModality}
                            />
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              )}
        {props.action == ACTIONS.VIEW && (
            <div className="ms-Grid" dir="ltr">
            <section className="sectionA" style={{margin: "1rem 0"}}>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    padding: "0px 0px",
                  }}
                >
                  {t("hospital.auto-assignment-settings")}
                </p>
              </section>
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-auto-assignment")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.autoAssignEnable ? "Yes" : "No"}</div>
                </div>
              </div>
              {!!autoAssignEnabled && (<>
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                      {t("hospital.enable-pediatric-assignment")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                      <div>{props.values.pediatricAssignmentEnabled ? "Yes" : "No"}</div>
                    </div>
                </div>

                {!!pediatricAssignmentEnabled && (
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">{t("hospital.pediatric-assignment-modality")}</div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl8">
                      <div>
                        {getModalityNames(props.values.selectedPediatricModalityId)}
                      </div>
                    </div>
                  </div>
                )}

                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                      {t("hospital.enable-exact-match")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                      <div>{props.values.exactMatchEnable ? "Yes" : "No"}</div>
                    </div>
                </div>
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <table className="borderless-table" style={{borderCollapse:"collapse", width:"100%"}}>
                        <thead>
                          <tr>
                            <th className="form-heading" style={{border:"none",padding:"8px",textAlign:"left",width:"30%"}}>Auto assignment Modality</th>
                            {getEnv("REACT_APP_VDC_PLATFORM") == "true" && 
                              <th className="form-heading" style={{border:"none",padding:"8px",textAlign:"left"}}>Sub Modality</th>
                            }
                          </tr>
                        </thead>
                        <tbody>
                        {props.values.autoAssignModalityWithSubModalityIds.map((modality, index)=>{
                          return(<>
                            {/* <td style={{border:"none",padding:"8px",textAlign:"left"}}>{modality.modalityName}</td> */}
                            {/* {modality.subModalities.length > 0 ?  <>
                              {getFormattedSubModalities(modality)}
                              
                            </>
                            : <td style={{border:"none",padding:"8px",textAlign:"left"}}>-</td>} */}
                              {/* <> */}
                              { getEnv("REACT_APP_VDC_PLATFORM") == "true" ? <>
                                {modality?.subModalities && modality.subModalities.length == 0 ? <>
                                <tr>
                                  <td style={{border:"none",padding:"8px",textAlign:"left"}}>{modality.modalityName}</td>
                                  <td style={{border:"none",padding:"8px",textAlign:"left"}}>-</td>
                                </tr>
                                </> : ""}
                                {modality?.subModalities.map((subMod, index)=>{
                                  return <tr>
                                  <td style={{border:"none",padding:"8px",textAlign:"left"}}>{modality.modalityName}</td>
                                  <td style={{border:"none",padding:"8px",textAlign:"left"}}>{subMod.serviceCode + ": " + subMod.serviceName}</td>    
                                  </tr>
                                  {/* <div key={index}>{subMod.serviceCode + ": " + subMod.serviceName}</div> */}
                                })}
                                </> : 
                                <tr>
                                  <td style={{border:"none",padding:"8px",textAlign:"left"}}>{modality.modalityName}</td>
                                </tr>
                              }

                          </>)
                        })}
                      </tbody>
                  </table>
                </div>
                </>)}
              </div>
        )
        }
        </>}
        </div>
      </>
    );
  }
  

export default AutoAssignmentAccess;
